import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

// Location lookups from the tender service (provinces, regions and their cities).
class LocationsService {
  getProvinces() {
    return ApiService.get(`${Config.api.tender.url}locations/provinces`).then((response) => response.data);
  }

  getRegions() {
    return ApiService.get(`${Config.api.tender.url}locations/regions`).then((response) => response.data);
  }

  // Optionally narrowed to a region (query param; regions are a lookup helper
  // only — the region never travels in the pre-project payload).
  getCities({ regionId = null } = {}) {
    const query = regionId ? `?regionId=${regionId}` : '';
    return ApiService.get(`${Config.api.tender.url}locations/cities${query}`).then((response) => response.data);
  }
}

export const locationsService = new LocationsService();
